export default __webpack_public_path__ + "static/media/qr.fe364de1.png";